import React, { useEffect, useState } from 'react'
import { Route, Link, Redirect, Switch, BrowserRouter as Router } from 'react-router-dom'
import { withCookies, Cookies } from 'react-cookie'

import './App.css'

import MetaTags from 'react-meta-tags'
import Auth from './Modules/Auth'
import LogoutFunction from './Containers/User/LogoutFunction'
import SignupNormal from './Containers/Signup/SignupNormal'
import ForgotPage from './Containers/User/ForgotPage'
import ForgotResetPage from './Containers/User/ForgotResetPage'
import MyPage from './Containers/User/MyPage'
import Withdrawal from './Containers/User/Withdrawal'
import WithdrawalComplete from './Containers/User/WithdrawalComplete'
import LoginPage from './Containers/User/LoginPage'
import IntroPage from './Containers/Intro/IntroPage'
import IntroCompletePage from './Containers/Intro/IntroCompletePage'
import IntroDetailPage from './Containers/Intro/IntroDetailPage'
import IntroMatterport from './Containers/Intro/IntroMatterport'
import IntroDashboard from './Containers/Intro/IntroDashboard'
import DashboardPage from './Containers/Dashboard/DashboardPage'
import DemandListPage from './Containers/Demand/DemandListPage'
import DemandDetailPage from './Containers/Demand/DemandDetailPage'
import DemandWritePage from './Containers/Demand/DemandWritePage'
import ReportListPage2 from './Containers/Report/ReportListPage2'
import ReportDetailPage from './Containers/Report/ReportDetailPage'
import TodoListPage from './Containers/Todo/TodoListPage'
import TodoDetailPage from './Containers/Todo/TodoDetailPage'
import TodoWritePage from './Containers/Todo/TodoWritePage'
import MeetingListPage from './Containers/Meeting/MeetingListPage'
import MeetingDetailPage from './Containers/Meeting/MeetingDetailPage'
import MeetingWritePage from './Containers/Meeting/MeetingWritePage'
import ContractListPage from './Containers/Contract/ContractListPage'
import ProjectListPage from './Containers/Project/ProjectListPage'
import PolicyPage from './Containers/Policy/PolicyPage'
import NoticePage from './Containers/Notice/NoticePage'
import SchedulePage from './Containers/Schedule/SchedulePage'
// import Events from './Libs/Events';
import WithTracker from './Libs/WithTracker'
import ReactGA from 'react-ga'
import ReactPixel from 'react-facebook-pixel'
import '../Res/scss/main.scss'
// import 'firebase/messaging'
// import * as firebase from 'firebase/app'

import { Provider } from 'react-redux'
import createStore from './Redux/store'
import reducers from './Redux/reducer'
import { composeWithDevTools } from 'redux-devtools-extension'
import ChatPage from './Containers/Chat/ChatPage'
import { ChatRootProvider } from '@aicon-dev/caas-chat'
import { CoreProvider } from '@aicon-dev/caas-core'
import Axios from 'axios'

const store = createStore(reducers, composeWithDevTools())

// const firebaseConfig = {
//     apiKey: 'AIzaSyBA-01SCjpUm4yCcx4oecTjRAykQXCjZTE',
//     authDomain: 'haus-planner.firebaseapp.com',
//     projectId: 'haus-planner',
//     storageBucket: 'haus-planner.appspot.com',
//     messagingSenderId: '487809238950',
//     appId: '1:487809238950:web:a26a65d6e228c1b4563167',
//     measurementId: 'G-Q5LZHXEYSP',
// }
// firebase.default.initializeApp(firebaseConfig)
// if (firebase.default.messaging.isSupported()) {
//     const messaging = firebase.default.messaging()
//     messaging
//         .requestPermission()
//         .then(function () {
//             return messaging.getToken() // 토큰을 받는 함수를 추가!
//         })
//         .then(function (token) {
//             console.log(token)

//             const d = new Date()
//             const exdays = 365
//             d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
//             const expires = 'expires=' + d.toUTCString()
//             document.cookie = 'FCM-TOKEN' + '=' + token + ';' + expires + ';path=/'
//         })
//         .catch(function (err) {
//             console.log('error FCM : ', err)
//         })

//     messaging.onMessage(function (payload) {
//         console.log(payload)
//         const title = payload.notification.title
//         const options = {
//             body: payload.notification.body,
//             icon: 'https://www.hausplanner.com/assets/img/favicon_haus.png',
//             click_action: payload.notification.click_action,
//         }
//         const notification = new Notification(title, options)
//     })
// }

const LoggedOutRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) =>
            Auth.isUserAuthenticated() ? (
                <Redirect
                    to={{
                        pathname: '/',
                        state: { from: props.location },
                    }}
                />
            ) : (
                <Component {...props} {...rest} />
            )
        }
    />
)

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        // render={props => (
        //   Auth.isUserAuthenticated() ? (
        //     <Component {...props} {...rest} />
        //   ) : (
        //     <ReactRedirect location="/main" />
        //   )
        // )}
        render={(props) => {
            if (!Auth.isUserAuthenticated()) {
                window.location.href = '/main'
                return null
            }
            return <Component {...props} {...rest} />
        }}
    />
)

// const ProjectRoute = ({ component: Component, ...rest }) => (

//     <Route
//         {...rest}
//         render={(props) => {
//             if (!Auth.isUserAuthenticated()) {
//                 window.location.href = '/main'
//                 return null
//                 // return <Redirect to="/main" />;
//             } else if (!Auth.selectedProject()) {
//                 return <Redirect to="/project" />
//             }
//             return <Component {...props} {...rest} />
//         }}
//     />
// )

const ProjectRoute = ({ component: Component, ...rest }) => {
    const [userId, setUserId] = useState('')
    const isAuth = Auth.isUserAuthenticated()

    const loadUser = () => {
        Axios.get(`${BACKEND_HOST}/auth/me`, {
            headers: {
                Authorization: `bearer ${Auth.getToken()}`,
            },
        })
            .then((res) => {
                setUserId(res.data._id)
            })
            .catch((err) => {
                console.log(err)
            })
    }

    useEffect(() => {
        if (!isAuth) return
        loadUser()
    }, [isAuth])

    return (
        <Route
            {...rest}
            render={(props) => {
                if (!Auth.isUserAuthenticated()) {
                    window.location.href = '/main'
                    return null
                    // return <Redirect to="/main" />;
                } else if (!Auth.selectedProject()) {
                    return <Redirect to="/project" />
                }
                return (
                    <ChatRootProvider
                        appId={SENDBIRD_APP_ID}
                        userId={userId || ''}
                        caasApiUrl={BACKEND_HOST}
                        caasAuthToken={Auth.getToken()}>
                        <Component {...props} {...rest} />
                    </ChatRootProvider>
                )
            }}
        />
    )
}

const PropsRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={(props) => <Component {...props} {...rest} />} />
)

class App extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            authenticated: false,
        }

        // Google Analytics
        ReactGA.initialize('UA-121059956-1', {
            debug: false,
            gaOptions: {
                userId: Auth.getToken(),
            },
        })

        // Facebook pixel
        const advancedMatching = {} // optional, more info: https://developers.facebook.com/docs/facebook-pixel/pixel-with-ads/conversion-tracking#advanced_match
        const options = {
            autoConfig: true,
            debug: false,
        }
        ReactPixel.init('247329555928075', advancedMatching, options)
    }

    UNSAFE_componentWillMount() {
        this.toggleAuthenticateStatus()
    }

    toggleAuthenticateStatus() {
        this.setState({ authenticated: Auth.isUserAuthenticated() })
    }

    render() {
        return (
            <CoreProvider language="ko">
                <Provider store={store}>
                    <Router>
                        <div className="app_wrap">
                            <MetaTags>
                                <title>스마트 건축 - 하우스플래너</title>
                                <meta
                                    name="naver-site-verification"
                                    content="c005b2867f76c684b551e07dbe175684b91f8b98"
                                />
                                <meta
                                    name="google-site-verification"
                                    content="yfxOL9hjGdWYiCgRLso6QoUui6HFJFRQxB_QwLwRY4Y"
                                />
                                <meta
                                    name="viewport"
                                    content="initial-scale=1.0,user-scalable=no,maximum-scale=1,width=device-width"
                                />
                                <link rel="shortcut icon" href="/assets/img/favicon_haus.png" />
                            </MetaTags>

                            <Switch>
                                <ProjectRoute
                                    exact
                                    path="/"
                                    component={WithTracker(DashboardPage)}
                                    toggleAuthenticateStatus={() => this.toggleAuthenticateStatus()}
                                />
                                <ProjectRoute exact path="/schedule" component={WithTracker(SchedulePage)} />
                            </Switch>
                            <Switch>
                                <ProjectRoute exact path="/intro" component={WithTracker(IntroPage)} />
                                <ProjectRoute exact path="/intro/detail/" component={WithTracker(IntroDetailPage)} />
                                <ProjectRoute exact path="/intro/dashboard/" component={WithTracker(IntroDashboard)} />
                                <ProjectRoute
                                    exact
                                    path="/intro/complete/"
                                    component={WithTracker(IntroCompletePage)}
                                />
                                <ProjectRoute exact path="/intro/scan3d/" component={WithTracker(IntroMatterport)} />
                            </Switch>
                            <Switch>
                                <PrivateRoute exact path="/project" component={WithTracker(ProjectListPage)} />
                            </Switch>
                            <Switch>
                                <ProjectRoute exact path="/report" component={WithTracker(ReportListPage2)} />
                                <Redirect exact path="/report/write/" to="/" />
                                <Redirect exact path="/report/write/:id" to="/" />
                                <ProjectRoute exact path="/report/:id" component={WithTracker(ReportDetailPage)} />
                            </Switch>
                            <Switch>
                                <ProjectRoute exact path="/demand" component={WithTracker(DemandListPage)} />
                                <ProjectRoute exact path="/demand/:id" component={WithTracker(DemandDetailPage)} />
                                <ProjectRoute exact path="/demand/write/:id" component={WithTracker(DemandWritePage)} />
                            </Switch>

                            <Switch>
                                <ProjectRoute exact path="/todo" component={WithTracker(TodoListPage)} />
                                <ProjectRoute exact path="/todo/write/" component={WithTracker(TodoWritePage)} />
                                <ProjectRoute exact path="/todo/write/:id" component={WithTracker(TodoWritePage)} />
                                <ProjectRoute exact path="/todo/:id" component={WithTracker(TodoDetailPage)} />
                            </Switch>
                            <Switch>
                                <ProjectRoute exact path="/meeting" component={WithTracker(MeetingListPage)} />
                                <ProjectRoute exact path="/meeting/write/" component={WithTracker(MeetingWritePage)} />
                                <ProjectRoute
                                    exact
                                    path="/meeting/write/:id"
                                    component={WithTracker(MeetingWritePage)}
                                />
                                <ProjectRoute exact path="/meeting/:id" component={WithTracker(MeetingDetailPage)} />
                            </Switch>
                            <Switch>
                                <LoggedOutRoute exact path="/forgot" component={ForgotPage} />
                                <LoggedOutRoute
                                    exact
                                    path="/forgot/reset/:id"
                                    component={ForgotResetPage}
                                    toggleAuthenticateStatus={() => this.toggleAuthenticateStatus()}
                                />
                            </Switch>
                            <Switch>
                                <PrivateRoute exact path="/withdrawal" component={WithTracker(Withdrawal)} />
                                <LoggedOutRoute
                                    exact
                                    path="/withdrawal/complete"
                                    component={WithTracker(WithdrawalComplete)}
                                />
                            </Switch>

                            <Switch>
                                <PropsRoute exact path="/signup/" component={SignupNormal} />
                                <PropsRoute exact path="/signup/normal" component={SignupNormal} />
                                {/* <PropsRoute exact path="/signup/business" component={SignupBusiness} /> */}
                                {/* <PropsRoute exact path="/signup/request" component={SignupRequest} /> */}
                            </Switch>

                            <ProjectRoute exact path="/chat" component={WithTracker(ChatPage)} />

                            <LoggedOutRoute
                                path="/login"
                                component={LoginPage}
                                toggleAuthenticateStatus={() => this.toggleAuthenticateStatus()}
                            />
                            <PropsRoute
                                path="/logout"
                                component={LogoutFunction}
                                toggleAuthenticateStatus={() => this.toggleAuthenticateStatus()}
                            />
                            <PrivateRoute path="/mypage" component={WithTracker(MyPage)} />
                            <PropsRoute exact path="/policy" component={PolicyPage} />
                            <PropsRoute exact path="/policy/service" component={PolicyPage} />
                            <PropsRoute exact path="/policy/privacy" component={PolicyPage} />
                            <ProjectRoute exact path="/notice" component={WithTracker(NoticePage)} />
                            <ProjectRoute path="/budget" component={WithTracker(ContractListPage)} />
                            {/* <Footer /> */}
                        </div>
                    </Router>
                </Provider>
            </CoreProvider>
        )
    }
}

export default withCookies(App)



// WEBPACK FOOTER //
// ./Src/App.js